import { Box, Paper, Tab, Tabs, Typography } from '@mui/material';
import { useState } from 'react';
import { AccountFormElement } from './StyledComponents';
import ProfileForm from './ProfileForm';
import PageHeader from '@/components/PageHeader/PageHeader';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export const CustomTabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`account-tabpanel-${index}`}
      aria-labelledby={`account-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: { xs: 2, md: 3 } }}>{children}</Box>}
    </div>
  );
};

export const tabProps = (index: number) => ({
  id: `account-tab-${index}`,
  'aria-controls': `account-tabpanel-${index}`,
});
const AccountPage = () => {
  const [value, setValue] = useState(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box
      sx={{ width: '100%', maxWidth: 1280, mx: 'auto', p: { xs: 2, md: 3 } }}
    >
      <PageHeader
        eyebrow="Account"
        title="Account settings"
        description="Review your profile and the organisation information associated with your account."
      />
      <AccountFormElement>
        <Paper variant="outlined" sx={{ overflow: 'hidden' }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="Account sections"
            sx={{ px: { xs: 1, md: 2 }, bgcolor: 'background.default' }}
          >
            <Tab label="Profile" {...tabProps(0)} />
            <Tab label="Settings" {...tabProps(1)} />
          </Tabs>
          <Box sx={{ borderTop: '1px solid', borderColor: 'divider' }}>
            <CustomTabPanel value={value} index={0}>
              <ProfileForm />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <Paper
                variant="outlined"
                sx={{ p: 2.5, bgcolor: 'background.default' }}
              >
                <Typography variant="subtitle1">Settings</Typography>
                <Typography variant="body2" color="text.secondary">
                  No additional account settings are currently available.
                </Typography>
              </Paper>
            </CustomTabPanel>
          </Box>
        </Paper>
      </AccountFormElement>
    </Box>
  );
};

export default AccountPage;
